import styled from '@emotion/styled';
import { Box } from '~Styles';
import { handyBreakpoint } from '~Styles/breakpoints';

/** Same highlight box as PromoCodeDiscount, tinted with the light POS Classic blue so the text stays readable on the dark modal */
export const InfoBox = styled(Box)`
  background-color: color-mix(in srgb, var(--colorPOSClassic11) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--colorPOSClassic11) 30%, transparent);
  border-radius: 8px;
  padding: 10px 14px;
  /* Long change lists scroll inside the box instead of growing the modal */
  max-height: 240px;
  overflow-y: auto;

  ${handyBreakpoint} {
    max-height: 128px;
  }
`;
